import { z } from "zod";

import { Codelist } from "@/data/codelists";

export const JobApplicationStatus = z.union([
  z.literal("SUBMITTED"),
  z.literal("IN_REVIEW"),
  z.literal("PRESENTED_TO_CLIENT"),
  z.literal("INTERVIEW"),
  z.literal("ACCEPTED"),
  z.literal("REJECTED"),
  z.literal("WITHDRAWN"),
  z.literal("DRAFT"),
  z.literal("DELETED"),
  z.literal("EXPIRED"),
]);

export type JobApplicationStatus = z.infer<typeof JobApplicationStatus>;

export const JobApplicationStatusCodelist = Codelist<JobApplicationStatus>(JobApplicationStatus);

export type JobApplicationStatusCodelist = z.infer<typeof JobApplicationStatusCodelist>;
